<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_vii"><strong>CONTENTS</strong></a></h2><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/foreword#foreword">Foreword: What Nurtured My Outrage, Really?</a> by Alice Walker</p>
<p class="toc"><a href="#/xhtml/preface#preface">Preface</a></p>
<p class="toc"><a href="#/xhtml/ack#ack">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/ch01#ch01">Mentor to the Movement: Howard Zinn, SNCC, and the Spelman College Freedom Struggle</a></p>
<p class="toc"><span href="#/xhtml/ch02#ch02" title="Link target outside of Sample">Diary Editor’s Note</span></p>
<p class="toct"><span href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>Howard Zinn’s Southern Diary</strong></span></p>
<p class="toct"><span href="#/xhtml/epilogue#epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/app01#app01" title="Link target outside of Sample">Appendix I. “On Liberty at Spelman,” March 11, 1963</span></p>
<p class="toc"><span href="#/xhtml/app02#app02" title="Link target outside of Sample">Appendix II. Debate on Abolishing the House Committee on Un-American Activities: Howard Zinn’s Opening Statement in Support of Abolition, Emory University, February 11, 1963</span></p>
<p class="toc"><span href="#/xhtml/notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/index#index" title="Link target outside of Sample">Index</span><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?cae558d6